import {types} from "mobx-state-tree";

import {
    hierarchy,
    pack,
} from 'd3-hierarchy';
import programElements from "../../assets/program-elements";
import moodBoardData from "../../assets/moodboard-data";

const Node = types
    .model('Node', {
        id: types.identifier,
        size: types.number,
        src: types.string,
        name: types.optional(types.string, ''),
        groups: types.array(types.string)
    }).actions(self => ({
        setSize(val) {
            self.size = val;
        }
    }));

export const CirclePackStore = types
    .model('CirclePackStore', {
        width: types.number,
        height: types.number,
        nodes: types.map(Node),
    })
    .volatile(self => ({
        circlePack: pack()
            .padding(2)
    }))
    .actions(self => ({
        setSize(width, height) {
            self.width = width;
            self.height = height;
            // console.log('setSize, width : ' + self.width);
        },
        addNode(node) {
            self.nodes.put(node);
        },
        setNodeSize(id, value) {
            self.nodes.get(id).setSize(value);
        },
    })).views(self => ({
        get packedCircles() {
            self.circlePack.size([self.width, self.height]);
            // console.log('Rectangle Getter called, width : ' + self.width);
            const topNode = {id: '_top_', children: []};
            const hierarchyLookup = {};//use efficient lookup by id since we can be looping over millions of items
            let parentGroup = topNode;
            for (let node of self.nodes.values()) {

                const groups = node.groups;
                parentGroup = topNode;
                groups.forEach((group, i) => {
                    const groupId = `${parentGroup.id}_${group}`;
                    if (!hierarchyLookup[groupId]) {
                        hierarchyLookup[groupId] = {id: groupId, children: [], value: 0, group: group};
                        parentGroup.children.push(hierarchyLookup[groupId]);
                    }
                    parentGroup = hierarchyLookup[groupId];
                });
                if (node.size > 0) {
                    parentGroup.children.push({id: node.id, value: node.size, src: node.src, name: node.name});
                }
                // parentGroup.value += node.size;
            }
            const root = hierarchy(topNode)
                .sum((d) => {
                    return d.value;
                });

            self.circlePack(root);

            const circles = [];
            const genRects = (d) => {
                if (d.data && d.data.id) {

                }
                circles.push({
                    id: d.data.id,
                    x: d.x,
                    y: d.y,
                    r: d.r,
                    src: d.data.src,
                });
                if (d.children) {
                    d.children.forEach((child, i) => {
                        genRects(child);
                    });
                }
            };

            genRects(root);
            return circles.filter((c) => c.r > 0 && c.src);
        }
    }));
export const circlePackStore = CirclePackStore.create({width: 1000, height: 750, nodes: {}});
moodBoardData.forEach((image, i) => {
    circlePackStore.addNode({
        id: image.key,
        src: image.img,
        size: Math.random() * 50,
        groups: ['main'],
    });
});
